import React from "react";
import "./Headerimage.css";

const Headerimage = ({ bgimg, children }) => {
  return (
    <div className="HeaderImage" style={{ backgroundImage: `url(${bgimg})` }}>
      <div className="header-text">{children}</div>
    </div>
  );
};

export default Headerimage;
